import AttachmentCommand from "@/components/attachments/command";

export default class Command {
  constructor(item) {
    this.lineNumber = item != null ? item.lineNumber : 1;
    this.qualityName = item != null ? item.qualityName : '';
    this.shape = item != null ? item.shape : 0;
    this.diameter = item != null ? item.diameter : '';
    this.length = item != null ? item.length : '';
    this.width = item != null ? item.width : '';
    this.quantity = item != null ? item.quantity : 1;
    this.semiFinishId = item != null ? item.semiFinishId : '';
    this.semiFinishDescription = item != null ? item.semiFinishDescription : '';
    this.articleId = item != null ? item.articleId : '';
    this.articleDescription = item != null ? item.articleDescription : '';
    this.colorId = item != null ? item.colorId : '';
    this.colorDescription = item != null ? item.colorDescription : '';
    this.attachment = item != null ? item.attachment : new AttachmentCommand();
  }
}
